import { render, staticRenderFns } from "./MoveableBlockEditor.v2.vue?vue&type=template&id=d6083d8e&scoped=true&"
import script from "./MoveableBlockEditor.v2.vue?vue&type=script&lang=js&"
export * from "./MoveableBlockEditor.v2.vue?vue&type=script&lang=js&"
import style0 from "./MoveableBlockEditor.v2.vue?vue&type=style&index=0&id=d6083d8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6083d8e",
  null
  
)

export default component.exports